import React, { useEffect, useState } from "react";
import { addDays, endOfMonth, format, isSameDay, startOfMonth } from "date-fns";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker, DefinedRange } from "react-date-range";
import { enUS } from "date-fns/locale";

const DateRange = ({ toggleDateRange, setToggleDateRange,onApply }) => {
  const [state, setState] = useState([
    {
      startDate: startOfMonth(new Date()),
      endDate: endOfMonth(new Date()),
      key: "selection",
    },
  ]);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const predefinedRanges = [];

  useEffect(() => {
    document
      .querySelectorAll(".rdrMonthName")[0]
      ?.classList?.add("rdrMonthNameFirst");
    document
      .querySelectorAll(".rdrMonthName")[1]
      ?.classList?.add("rdrMonthNameSecond");
  }, [showDatePicker, toggleDateRange]);

  const handlePropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      <span>
        {`${format(state[0].startDate, "MMM dd,yy")} - ${format(
          state[0].endDate,
          "MMM dd,yy"
        )}`}
      </span>

      {toggleDateRange && (
        <div onClick={handlePropagation} className="bg-white date-range-labels">
          <DefinedRange
            ranges={state}
            locale={enUS}
            onChange={(item) => setState([item.selection])}
            staticRanges={predefinedRanges} // no "Custom Date" inside this
            inputRanges={[]} // prevent manual inputs
            className="range-dropdown"
          />

          <div className="date-dropdown">
            <DateRangePicker
              locale={enUS}
              onChange={(item) => setState([item.selection])}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={state}
              direction="horizontal"
              weekdayDisplayFormat="EEEEEE"
              showMonthAndYearPickers={false}
              staticRanges={predefinedRanges}
            />
            <div className="action-btns">
              <span>
                {`${format(state[0].startDate, "MM/dd/yy")} - ${format(
                  state[0].endDate,
                  "MM/dd/yy"
                )}`}
              </span>
              <button
                onClick={() => setToggleDateRange(false)}
                className="applyBtn btn btn-sm btn-danger"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const from_date = format(state[0].startDate, "yyyy-MM-dd");
                  const to_date = format(state[0].endDate, "yyyy-MM-dd");

                  if (onApply) {
                    onApply({ from_date, to_date });
                  }

                  setToggleDateRange(false);
                }}
                className="applyBtn btn btn-sm btn-primary"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DateRange;
